<mat-card class="cardWithShadow theme-card"
  class="b-t-1 swipe-container"
  (touchstart)="touchStart($event)"
  (touchmove)="touchMove($event)"
  (touchend)="touchEnd($event)">
  <mat-tab-group
  >
    <mat-tab label="Empresa"
      (touchstart)="stopPropagation($event)"
      (touchmove)="stopPropagation($event)"
      (touchend)="stopPropagation($event)">
      <mat-card-header style="margin-bottom: 15px;">
        <mat-card-title class="m-b-0">
          Portafolio
        </mat-card-title>
      </mat-card-header>
      <mat-card-content *ngIf="!spinnerShow" class="b-t-1 container_article">
        <div class="row">
          <div class="col-md-6">
            <table>
              <tr>
                <td>
                  <h4>Ejecutivo Factoring:</h4>
                </td>
                <td>
                  <h4 class="detalle">
                    {{ portafolio?.executiveFactoring || "No Asignado" }}
                  </h4>
                </td>
              </tr>
            </table>
          </div>

          <div class="col-md-6">
            <table>
              <tr>
                <td>
                  <h4>Ejecutivo Garantías:</h4>
                </td>
                <td>
                  <h4 class="detalle">
                    {{ portafolio?.executive || "No Asignado" }}
                  </h4>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </mat-card-content>

      <mat-card-header style="margin-bottom: 15px;">
        <mat-card-title class="m-b-0">
          Contacto
        </mat-card-title>
      </mat-card-header>

      <div class="container_btn_info" style="position: absolute;">
        <button
          style="margin-bottom: 5px; margin-top: 5px"
          type="button"
          mat-stroked-button
          color="primary"
          (click)="updateInfo(info)"
        >
          Actualizar Información
        </button>
      </div>

      <mat-card-content *ngIf="!spinnerShow" class="b-t-1 container_article">
        <div class="row">
          <div class="col-md-6">
            <table>
              <tr>
                <td>
                  <h4>Nombre Contacto:</h4>
                </td>
                <td>
                  <h4 class="detalle">
                    {{ info?.contactName || "No hay información" }}
                  </h4>
                </td>
              </tr>
              <!-- <tr>
                <td>
                  <h4>RUT:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.rut">{{ info.rut }}</h4>
                  <h4 class="detalle" *ngIf="!info?.rut">No hay Informacion</h4>
                </td>
              </tr> -->
              <tr>
                <td>
                  <h4>Teléfono:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.phone">{{ info.phone }}</h4>
                  <h4 class="detalle" *ngIf="!info?.phone">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Email:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.email">{{ info.email }}</h4>
                  <h4 class="detalle" *ngIf="!info?.email">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Inicio de Actividad:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.startActivity">
                    {{ info.startActivity | date : "dd/MM/yyyy" }}
                  </h4>
                  <h4 class="detalle" *ngIf="!info?.startActivity">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
            </table>
          </div>

          <div class="col-md-6">
            <table>
              <tr>
                <td>
                  <h4>Región:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.region">
                    {{ info.region }}
                  </h4>
                  <h4 class="detalle" *ngIf="!info?.region">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Direccion:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.address">
                    {{ info.address }}
                  </h4>
                  <h4 class="detalle" *ngIf="!info?.address">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Sitio Web:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="info?.website">
                    <a href="https://{{ info.website }}" target="_blank">{{
                      info.website
                    }}</a>
                  </h4>
                  <h4 class="detalle" *ngIf="!info?.website">
                    No hay Informacion
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Tamaño de la Empresa:</h4>
                </td>
                <td>
                  <h4 class="detalle">
                    {{ info?.businessSize || "No hay información" }}
                  </h4>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </mat-card-content>

      <mat-card-content>
        <div class="row">
          <div class="col-md-6">
            <mat-card-header>
              <mat-card-title class="m-b-0">Fogape</mat-card-title>
            </mat-card-header>
            <hr class="linea-separadora" />
            <div class="row">
              <div class="col">
                <table *ngIf="fogape; else cargando">
                  <tr>
                    <td>
                      <h4>Eligibilidad de Fogape:</h4>
                    </td>
                    <td>
                      <h4 class="detalle" *ngIf="fogape.hasFogape">Si</h4>
                      <h4 class="detalle" *ngIf="!fogape.hasFogape">No</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h4>Ultima consulta Fogape:</h4>
                    </td>
                    <td>
                      <h4 class="detalle" *ngIf="fogape.date">
                        {{ fogape.date | date : "dd/MM/yyyy" }}-{{
                          fogape?.date | date : "shortTime"
                        }}
                        Hrs
                      </h4>
                      <h4 class="detalle" *ngIf="!fogape.date">
                        No hay Informacion
                      </h4>
                    </td>
                  </tr>
                  <tr *ngIf="fogape.hasFogape">
                    <td>
                      <h4>Deuda Fogape:</h4>
                    </td>
                    <td>
                      <h4 class="detalle" *ngIf="fogape.globalDebt">
                        {{
                          fogape.globalDebt
                            | currency : " " : "symbol" : "3.0-0"
                        }}
                        UF
                      </h4>
                      <h4 class="detalle" *ngIf="!fogape.globalDebt">0UF</h4>
                    </td>
                  </tr>
                  <tr *ngIf="!fogape.hasFogape">
                    <td>
                      <h4>Observación:</h4>
                    </td>
                    <td>
                      <h4 class="detalle">{{ fogape.observation }}</h4>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col">
                <table *ngIf="fogape">
                  <tr>
                    <td>
                      <h4>Programas Pre-Elegibles</h4>
                    </td>
                  </tr>
                  <tr *ngFor="let program of fogape.availablePrograms">
                    <td *ngIf="!fogape.hasRestriction">
                      {{ program }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <mat-card-header>
              <mat-card-title class="m-b-0">Resumen SII</mat-card-title>
            </mat-card-header>
            <hr class="linea-separadora" />
            <div *ngIf="infoSii; else noDataSII">
              <table>
                <tr>
                  <td>
                    <h4>Conectado a SII:</h4>
                  </td>
                  <td>
                    <h4 class="detalle" *ngIf="infoSii?.siiValidationState == 2">Conectado</h4>
                    <h4 class="detalle" *ngIf="infoSii?.siiValidationState != 2">Desconectado</h4>
                  </td>
                </tr>
                <tr *ngIf="!infoSii?.mensaje">
                  <td>
                    <h4>Fecha actualización password:</h4>
                  </td>
                  <td>
                    <h4 class="detalle" *ngIf="infoSii?.siiPasswordUpdate">
                      {{ infoSii?.siiPasswordUpdate | date : "dd/MM/yyyy" }}
                    </h4>
                    <h4 class="detalle" *ngIf="!infoSii?.siiPasswordUpdate">
                      -
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Estado validación password:</h4>
                  </td>
                  <td *ngIf="infoSii?.mensaje">
                    <h4
                      class="detalle"
                    >
                    {{ infoSii?.mensaje }}
                    </h4>
                  </td>
                  <td *ngIf="!infoSii?.mensaje">
                    <h4
                      class="detalle"
                      *ngIf="infoSii?.siiValidationState == 0"
                    >
                      En progreso
                    </h4>
                    <h4
                      class="detalle"
                      *ngIf="infoSii?.siiValidationState == 1"
                    >
                      Contraseña Incorrecta
                    </h4>
                    <h4
                      class="detalle"
                      *ngIf="infoSii?.siiValidationState == 2"
                    >
                      Validada
                    </h4>
                    <h4 class="detalle" *ngIf="!infoSii?.siiValidationState">
                      Sin Informacion
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Fecha validación password:</h4>
                  </td>
                  <td>
                    <h4
                      class="detalle"
                      *ngIf="infoSii?.siiPaswordValidationDate"
                    >
                      {{
                        infoSii?.siiPaswordValidationDate | date : "dd/MM/yyyy"
                      }}
                    </h4>
                    <h4
                      class="detalle"
                      *ngIf="!infoSii?.siiPaswordValidationDate"
                    >
                      -
                    </h4>
                  </td>
                </tr>
              </table>
            </div>

            <ng-template #noDataSII>
              <h4 style="text-align: center">No se encontro SII</h4>
            </ng-template>
          </div>
        </div>
      </mat-card-content>

      <mat-card-content>
        <mat-card-header>
          <mat-card-title class="m-b-0">Actividad Económica</mat-card-title>
        </mat-card-header>

        <!-- <hr class="linea-separadora" /> -->

        <div
          *ngIf="existeActividadEconomica == true; else noDataAC"
          class="table-responsive"
        >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="description">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="th-title"
                style="width: 62%"
              >
                Descripción
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef class="th-title">
                Fecha Inicio
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.startDate | date : "dd/MM/yyyy" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef class="th-title">
                Fecha Termino
              </th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.endDate == null ? "Sin información" : element.endDate
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="economicActivityCode">
              <th mat-header-cell *matHeaderCellDef class="th-title">Código</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.economicActivityCode == null
                    ? "Sin información"
                    : element.economicActivityCode
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="iva">
              <th mat-header-cell *matHeaderCellDef class="th-title">
                Declara IVA
              </th>
              <td mat-cell *matCellDef="let element">
                <i-tabler
                  *ngIf="element.iva == true"
                  name="circle-check-filled"
                  class="icon-20"
                  style="color: mediumspringgreen"
                ></i-tabler>

                <i-tabler
                  *ngIf="element.iva == false"
                  name="circle-x-filled"
                  class="icon-20"
                  style="color: red"
                ></i-tabler>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>

        <ng-template #noDataAC>
          <h3 style="text-align: center">No se encontro actividad</h3>
        </ng-template>
      </mat-card-content>
      <hr class="linea-separadora" />
      <mat-card-content>
        <mat-card-header>
          <mat-card-title class="m-b-0">
            Malla societaria

            <button 
              [disabled]="enableCompanyMesh()"
              type="button"
              (click)="openCompanyMeshModal(url)"
              mat-mini-fab
              style="margin-left: 10px"              
              matTooltip="Visualizar malla societaria"
            >
              <i-tabler class="icon-20" name="git-fork"> </i-tabler>
            </button>
          </mat-card-title>
        </mat-card-header>
        <app-partner-table
          [receiveBoolean]="receiveBooleanOwners"
        ></app-partner-table>
      </mat-card-content>
    </mat-tab>
    <mat-tab label="Mercado Publico">
      <mat-card-content>
        <iframe
          *ngIf="this.MPDashboardUrl"
          [src]="this.MPDashboardUrl"
          style="width: 100%; height: 100vh"
          frameBorder="0"
        ></iframe>
      </mat-card-content>
    </mat-tab>
    <mat-tab label="SAGR">
      <div class="divContenedor">
        <div class="row">
          <div class="col-5">
            <table>
              <tr>
                <td>
                  <h4>Linea aprobada garantías SGR:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="infoLegacy?.linea">
                    {{ infoLegacy?.linea | currency : "CLP" }}
                  </h4>
                  <h4 class="detalle" *ngIf="!infoLegacy?.linea">$0</h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Linea disponible garantías SGR:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="infoLegacy?.availableLine">
                    {{ infoLegacy?.availableLine | currency : "CLP" }}
                  </h4>
                  <h4 class="detalle" *ngIf="!infoLegacy?.availableLine">
                    $0
                  </h4>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Linea utilizada garantías SGR:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="infoLegacy?.totalUsedLine">
                    {{ infoLegacy?.totalUsedLine | currency : "CLP" }}
                  </h4>
                  <h4 class="detalle" *ngIf="!infoLegacy?.totalUsedLine">
                    $0
                  </h4>
                </td>
              </tr>
              <tr *ngIf="infoLegacy?.availableWarrantiesCount != 0">
                <td>
                  <h4>Total riesgo vigente:</h4>
                </td>
                <td>
                  <h4 class="detalle" *ngIf="infoLegacy?.totalUsedLine">
                    {{ infoLegacy?.totalUsedLine | currency : "CLP" }}
                  </h4>
                  <h4 class="detalle" *ngIf="!infoLegacy?.totalUsedLine">
                    $0
                  </h4>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-5">
            <div *ngIf="infoLegacy; else noDataSGR">
              <table>
                <tr>
                  <td>
                    <h4>Total riesgo historico:</h4>
                  </td>
                  <td>
                    <h4 class="detalle" *ngIf="infoLegacy?.totalRiskTaken">
                      {{ infoLegacy?.totalRiskTaken | currency : "CLP" }}
                    </h4>
                    <h4 class="detalle" *ngIf="!infoLegacy?.totalRiskTaken">
                      $0
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Nº certificados vigentes:</h4>
                  </td>
                  <td>
                    <h4
                      class="detalle"
                      *ngIf="infoLegacy?.availableWarrantiesCount"
                    >
                      {{ infoLegacy?.availableWarrantiesCount }}
                    </h4>
                    <h4
                      class="detalle"
                      *ngIf="!infoLegacy?.availableWarrantiesCount"
                    >
                      0
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Nº certificados totales:</h4>
                  </td>
                  <td>
                    <h4
                      class="detalle"
                      *ngIf="infoLegacy?.totalWarrantiesCount"
                    >
                      {{ infoLegacy?.totalWarrantiesCount }}
                    </h4>
                    <h4
                      class="detalle"
                      *ngIf="!infoLegacy?.totalWarrantiesCount"
                    >
                      0
                    </h4>
                  </td>
                </tr>
              </table>
            </div>

            <ng-template #noDataSGR>
              <h4 style="text-align: center">No se encontro actividad</h4>
            </ng-template>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Contacto">
      <mat-card-content>
        <div class="row">
          <div class="col-md-12">          
            <app-list-contact
              [infoClientTable]="info"
            ></app-list-contact>
            <ng-template #noDataSGR>
              <h4 style="text-align: center">No se encontro actividad</h4>
            </ng-template>
          </div>
        </div>
      </mat-card-content>
    </mat-tab>
  </mat-tab-group>
</mat-card>

<ng-template #cargando style="margin: auto">
  <div style="text-align: center">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-template>
